export const DEFAULT_CO2_PER_TREE = 22; // kg CO2/tree/year — fallback only; Strapi global co2_sequestation is authoritative

export interface FallbackPlantRates {
  geotaggedRate: number;
  nonGeotaggedRate: number;
}

const INR_FALLBACK_RATES: FallbackPlantRates = {
  geotaggedRate: 175,
  nonGeotaggedRate: 150,
};

const DEFAULT_FALLBACK_RATES: FallbackPlantRates = {
  geotaggedRate: 10,
  nonGeotaggedRate: 5,
};

export function getFallbackPlantRates(currency: string): FallbackPlantRates {
  return currency === "INR" ? INR_FALLBACK_RATES : DEFAULT_FALLBACK_RATES;
}
